"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EyeOpen = function EyeOpen(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M12.5 15.1041C11.985 15.1041 11.4815 14.9514 11.0532 14.6652C10.625 14.3791 10.2912 13.9723 10.0941 13.4965C9.89697 13.0206 9.8454 12.497 9.94588 11.9919C10.0464 11.4867 10.2944 11.0227 10.6586 10.6585C11.0228 10.2943 11.4868 10.0463 11.992 9.94579C12.4971 9.84531 13.0207 9.89688 13.4966 10.094C13.9724 10.2911 14.3791 10.6249 14.6653 11.0531C14.9514 11.4814 15.1042 11.9849 15.1042 12.4999C15.1034 13.1904 14.8288 13.8523 14.3406 14.3405C13.8524 14.8287 13.1904 15.1033 12.5 15.1041ZM12.5 10.9374C12.191 10.9374 11.8889 11.0291 11.6319 11.2007C11.375 11.3724 11.1747 11.6165 11.0564 11.902C10.9382 12.1875 10.9072 12.5017 10.9675 12.8047C11.0278 13.1078 11.1766 13.3863 11.3952 13.6048C11.6137 13.8233 11.8921 13.9721 12.1952 14.0324C12.4983 14.0927 12.8124 14.0617 13.098 13.9435C13.3835 13.8252 13.6275 13.6249 13.7992 13.368C13.9709 13.111 14.0625 12.809 14.0625 12.4999C14.062 12.0857 13.8973 11.6885 13.6043 11.3956C13.3114 11.1027 12.9143 10.9379 12.5 10.9374Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 17.1875C10.7723 17.1928 9.06847 16.7842 7.53107 15.9959C6.04638 15.2343 4.7537 14.146 3.75025 12.8128C3.68248 12.7226 3.64584 12.6128 3.64584 12.5C3.64584 12.3872 3.68248 12.2774 3.75025 12.1872C4.75379 10.854 6.04659 9.76563 7.53141 9.00409C9.0707 8.2208 10.7734 7.8125 12.5005 7.8125C14.2276 7.8125 15.9303 8.2208 17.4696 9.00409C18.9543 9.76567 20.247 10.854 21.2504 12.1872C21.3182 12.2774 21.3548 12.3872 21.3548 12.5C21.3548 12.6128 21.3182 12.7226 21.2504 12.8128C20.2469 14.1461 18.9541 15.2344 17.4692 15.9959C15.9317 16.7842 14.2278 17.1928 12.5 17.1875ZM4.82817 12.5C5.69896 13.5657 6.7805 14.4401 8.00499 15.0683C9.39756 15.7767 10.9378 16.1459 12.5002 16.1459C14.0625 16.1459 15.6028 15.7767 16.9953 15.0683C18.2199 14.4402 19.3016 13.5658 20.1725 12.5C19.3017 11.4343 18.2201 10.5599 16.9956 9.9317C15.6031 9.22338 14.0628 8.85417 12.5005 8.85417C10.9381 8.85417 9.39788 9.22338 8.00531 9.9317C6.7807 10.5599 5.69905 11.4342 4.82817 12.5Z",
    fill: props.foregroundColor
  }));
};

EyeOpen.defaultProps = {
  altText: "EyeOpen",
  foregroundColor: "#2D5AB4"
};
EyeOpen.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = EyeOpen;
exports.default = _default;